/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import FuseAnimate from '@/@fuse/core/FuseAnimate';
import CustomButton from '@/app/customComponents/CustomButton/CustomButton';
import { getAllRooms, getRosterTypes } from '@/app/services/rooms/rooms';
import * as Actions from '@/app/store/actions';
import {
	Dialog,
	DialogContent,
	FormControl,
	FormHelperText,
	IconButton,
	InputLabel,
	MenuItem,
	Paper,
	Select,
	Table,
	TableBody,
	TableCell,
	TableContainer,
	TableHead,
	TableRow,
} from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import { useEffect, useRef, useState } from 'react';
import Dropzone from 'react-dropzone';
import { useDispatch } from 'react-redux';
import FileValidator from './FileValidator';
import ProcareValidator from './ProcareValidator';
import './Students.css';
import { useNavigate } from 'react-router-dom';

const SubmitRoster = () => {
	const dispatch = useDispatch();
	const inputRef = useRef(null);
	const [open, setOpen] = useState(false);
	const [rooms, setRooms] = useState([]);
	const [rosterTypes, setRosterTypes] = useState([]);
	const [rosterType, setRosterType] = useState('');
	const [rosterErr, setRosterErr] = useState('');
	const navigate = useNavigate();

	const handleClickOpen = () => {
		if (rosterType) {
			setOpen(true);
		} else {
			setRosterErr('Required');
		}
	};

	const handleClose = () => {
		setOpen(false);
	};

	useEffect(() => {
		let isMounted = true;
		getAllRooms().then((res) => {
			if (!isMounted) return;
			setRooms(res.data.map((room) => room.name));
		});
		getRosterTypes().then((res) => {
			console.log(res.data.data);
			if (!isMounted) return;
			setRosterTypes(res.data.data);
		});
		return () => {
			isMounted = false;
		};
	}, []);

	const handleSubmit = (file) => {
		if (file) {
			const validExtensions = rosterType === 'procare' ? ['csv'] : ['xlsx', 'xls'];
			if (!validExtensions.includes(file?.name?.split('.')?.at(-1)?.toLowerCase())) {
				dispatch(
					Actions.showMessage({
						message: `${rosterType === 'procare' ? 'Only csv files are allowed!' : 'Only excel files are allowed!'}`,
						autoHideDuration: 2500,
						variant: 'error',
					})
				);
				return;
			}
			setOpen(false);
			dispatch(
				Actions.openDialog({
					children:
						rosterType === 'procare' ? (
							<ProcareValidator file={file} rooms={rooms} type="local" />
						) : (
							<FileValidator file={file} rooms={rooms} type="local" />
						),
					maxWidth: '',
				})
			);
		} else {
			dispatch(
				Actions.showMessage({
					message: 'Failed to Post File.',
					autoHideDuration: 2000,
					variant: 'error',
				}),
				setOpen(false)
			);
		}
	};

	const onSelectFile = (e) => {
		if (!e.target.files || e.target.files.length === 0) {
			return;
		}
		handleSubmit(e.target.files[0]);
	};

	const handleDropFile = (file) => {
		if (!file[0]) {
			return;
		}
		handleSubmit(file[0]);
	};

	return (
		<FuseAnimate animation="transition.slideLeftIn" duration={600}>
			<div style={{ padding: 50 }}>
				<div className="form-heading" style={{ fontSize: '20px' }}>
					<span className="">
						<IconButton
							onClick={() => {
								navigate(-1);
							}}
						>
							<img alt="filter" className="backBtn-img" src="assets/images/arrow-long.png" width="24px" />
						</IconButton>
					</span>
					Student Roster
				</div>
				<div className="form-container bg-white">
					<form>
						<h2 className="form-section-heading" style={{ fontSize: '18px' }}>
							Submit Your Roster
						</h2>
						<hr />
						<div className="roster-main-div">
							<div className="para-one-heading">
								<p className="point-one">1</p>
								<h2 style={{ fontSize: '18px' }}>Prepare Your Roster</h2>
							</div>
							<div className="para-one-content flex justify-between">
								<div>
									<p className="paragraph-one">
										You will need a file with the student and family information. Otherwise, you can use our{' '}
										<a href="assets/files/UploadRoster.xlsx" style={{ cursor: 'pointer' }} target="_blank">
											Roster Template .
										</a>
									</p>
									{/* The column is optional and matched by name, so rosters
									    saved from the previous template still import. */}
									<p className="paragraph-one mt-8 text-13 text-gray-600">
										<strong>Enrollment Start Date</strong> is optional. Leave it blank for children starting now; give a
										future date and the child is added inactive, becomes active on that date, and their parent&apos;s
										app invite is held until 3 days before they start — or until the next daily send, for a child
										starting sooner than that.
									</p>
								</div>

								<div style={{ width: '100%', display: 'block' }}>
									<TableContainer className="submit-roaster-table" component={Paper} id="Scrollable-table">
										<Table className="student-table" stickyHeader style={{ width: '100%' }}>
											<TableHead>
												<TableRow>
													<TableCell align="left" className="bg-white studentTableHeader" style={{ width: '25%' }}>
														Student Name
													</TableCell>
													<TableCell align="left" className="bg-white studentTableHeader" style={{ width: '25%' }}>
														Rooms
													</TableCell>
													<TableCell align="left" className="bg-white studentTableHeader" style={{ width: '25%' }}>
														Parent Name
													</TableCell>
													<TableCell
														align="left"
														className="bg-white studentTableHeader"
														colSpan={8}
														component="th"
														scope="row"
														style={{ width: '25%' }}
													>
														Parent Email
													</TableCell>
												</TableRow>
											</TableHead>
											<TableBody className="">
												<TableRow>
													<TableCell>Alex Smith</TableCell>
													<TableCell>Infants</TableCell>
													<TableCell>Joshua Marshall</TableCell>
													<TableCell>joshua@gmail.com</TableCell>
												</TableRow>
												<TableRow>
													<TableCell>Mai Doe</TableCell>
													<TableCell>Toddlers</TableCell>
													<TableCell>Sarah Jhonson</TableCell>
													<TableCell>sarah@gmail.com</TableCell>
												</TableRow>
											</TableBody>
										</Table>
									</TableContainer>
								</div>
							</div>

							<div className="para-two-heading">
								<p className="point-two">2</p>
								<h2 style={{ fontSize: '18px' }}>Submit Your File</h2>
							</div>
							<div className="para-two-content flex justify-between items-center">
								<div className="para-two-content-paragraph">
									<p>Upload your roster and the perfect day will take care of the rest.</p>
								</div>
								<div className="submit-file-div">
									<div className="upload-file-div">
										<div className="w-full">
											<FormControl className="w-1/2 mx-auto mb-32" error={!!rosterErr} required>
												<InputLabel id="roster_type_label">Select</InputLabel>
												<Select
													id="roster_type"
													label="Select"
													labelId="roster_type_label"
													name="roster_type"
													onChange={(e) => {
														setRosterType(e.target.value);
														setRosterErr('');
													}}
													placeholder="Select"
												>
													{rosterTypes.map((item) => (
														<MenuItem key={item.slug} value={item.slug}>
															<div className="flex">
																<img alt="" src={item.photo} />
																<div>{item.name}</div>
															</div>
														</MenuItem>
													))}
												</Select>
												{rosterErr ? (
													<FormHelperText>
														<div className="text-pd-xs">{rosterErr}</div>
													</FormHelperText>
												) : null}
											</FormControl>
										</div>
										<div className="flex justify-center mb-16">
											<img alt="" src="assets/images/roster-upload-img.png" width={70} />
										</div>
										<CustomButton
											fontSize="15px"
											height="40px"
											onClick={handleClickOpen}
											variant="primary"
											width="200px"
										>
											Submit Your Roster
										</CustomButton>

										<Dialog
											aria-describedby="alert-dialog-description"
											aria-labelledby="alert-dialog-title"
											onClose={handleClose}
											open={open}
										>
											<div className="dialog-header">
												<p style={{ fontSize: '20px', fontWeight: '700' }}>Upload Files</p>
												<div className="dialog-icon">
													<IconButton onClick={handleClose}>
														<CloseIcon />
													</IconButton>
												</div>
											</div>
											<DialogContent
												style={{
													justifyContent: 'center',
													textAlign: 'center',
													marginBottom: 20,
												}}
											>
												<Dropzone multiple={false} onDrop={handleDropFile}>
													{({ getRootProps }) => (
														<div {...getRootProps({ className: 'dropzone' })}>
															<div className="fileUpload-div">
																<div className="cloud-div">
																	<div className="cloud" onClick={() => inputRef.current.click()}>
																		<img alt="computer" height="20%" src="assets/images/cloud.svg" width="20%" />
																	</div>
																	<input
																		accept=".xlsx, .xls"
																		className="hidden"
																		id="fileSelect"
																		name="fileSelect"
																		onChange={onSelectFile}
																		ref={inputRef}
																		type="file"
																	/>
																	<p>Drag & drop your files here</p>
																	<span>OR</span>
																	<div
																		style={{
																			justifyContent: 'center',
																			alignSelf: 'center',
																			display: 'flex',
																			width: '100%',
																		}}
																	>
																		<CustomButton
																			fontSize="15px"
																			height="40px"
																			marginTop={10}
																			onClick={() => inputRef.current.click()}
																			type="file"
																			variant="primary"
																			width="180px"
																		>
																			Browse Files
																		</CustomButton>
																	</div>
																</div>
															</div>
														</div>
													)}
												</Dropzone>
											</DialogContent>
										</Dialog>
									</div>
								</div>
							</div>
						</div>
					</form>
				</div>
			</div>
		</FuseAnimate>
	);
};

export default SubmitRoster;
